import Button from '@/components/base/Button';

export default function FinalCTA() {
  return (
    <section className="py-16 md:py-20 bg-primary-50">
      <div className="max-w-[720px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
          プロジェクトの整理を、AIに任せてみませんか？
        </h2>
        <p className="text-base text-foreground-600 mb-8">
          資料をアップロードし、AIの提案を確認するところから始められます。<br />
          無料でお試しください（プロジェクト1件・メンバー3名まで／期限なし）。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Button to="/free-trial/" size="lg" dataCtaName="free_trial" dataCtaLocation="bottom">
            無料で今すぐお試し
          </Button>
          <Button to="/contact/" variant="outline" size="lg" dataCtaName="demo_contact" dataCtaLocation="bottom">
            デモ・導入相談を予約する
          </Button>
        </div>
      </div>
    </section>
  );
}
